<a href="#" (click)="openModal($event)"
  ><em class="flag-us flag-24"></em>&nbsp;{{ currentLanguageView }}</a
>

@if(isModalOpen) {
<div
  class="modal-backdrop"
  (click)="onBackdropClick($event)"
  (keydown.enter)="onBackdropClick($event)"
  tabindex="-1"
>
  <div class="modal">
    <span
      class="close-button"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"
      tabindex="1"
    ></span>

    <div class="modal-body">
      <div class="lang-container">
        @for (language of languages; track language) {
          @if (currentLanguage !== language.value) {
            <div
              class="lang-item"
              (click)="selectLanguage(language)"
              (keydown)="selectLanguage(language)"
              tabindex="0"
            >
              {{ language.name }}
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>

}
